import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Accreditation_Section from "./Accreditation_section/Accreditation_Section";
import Admission_Process from "./admission_process/Admission_Process";
import Alumini_Voices from "./alumini-voices/Alumini_Voices";
import Certificate from "./certificate/Certificate";
import Difference_Section from "./difference_section/Difference_Section";
import Dpu_alumni from "./dpu_alumni/Dpu_alumni";
import Dpu_Learn_Ai_Tool_Swiper from "./dpu_learn_ai_tool_swiper/Dpu_Learn_Ai_Tool_Swiper";
import Dpu_Mca_Alumini from "./dpu_mca_alumini/Dpu_Mca_Alumini";
import FAQ from "./faq/FAQ";
import Program_takeway from "./program_takeway/Program_takeway";
import Specialization_Banner from "./specialization-banner/Specialization_Banner";
import Who_We_Are from "./who_we_are/Who_We_Are";
import WhyOnlineBcom from "./Why_Online_Bcom/WhyOnlineBcom";
import Fee_Structure from "./fee_structure/Fee_Structure";
import Program_Structure from "./program_structure/Program_Structure";

function Home() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;

    let targetId = "home"; // default

    if (path.includes("programs")) {
      targetId = "programs";
    } else if (path.includes("admission_process")) {
      targetId = "admissions";
    } else if (path.includes("eligibility-criteria")) {
      targetId = "eligibility";
    } else if (path.includes("fee_structure")) {
      targetId = "fees";
    }

    const el = document.getElementById(targetId);

    if (el) {
      setTimeout(() => {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 100);
    }
  }, [location]);

  return (
    <>
      <Specialization_Banner />
      <Accreditation_Section />
      <Who_We_Are />
      <WhyOnlineBcom />
      {/* <div id="programs">
        <Program_Structure />
      </div> */}

      <div id="fees">
        <Fee_Structure />
      </div>

      {/* <Learn_ai /> */}

      <Program_takeway />

      <Dpu_Learn_Ai_Tool_Swiper />

      {/* <div id="programs">
        <BCA_Specializations />
      </div> */}

      <Difference_Section />
      <Certificate />

      <div id="admissions">
        <Admission_Process />
      </div>

      <Alumini_Voices />
      <Dpu_Mca_Alumini />
      <FAQ />
      <Dpu_alumni />
    </>
  );
}

export default Home;
